import { Card, Stack, Typography, Box } from "@mui/joy";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import GradingRoundedIcon from "@mui/icons-material/GradingRounded";

interface MarkingSchemeCardProps {
  exam: any;
}

export default function MarkingSchemeCard({ exam }: MarkingSchemeCardProps) {
  if (!exam.markingSchemeArtifactUri || exam.status != "graded") return null;

  return (
    <Card
      sx={{
        position: "relative",
        background: "#FFF3E0",
        border: "none",
        overflow: "hidden",
        transition: "background-color 0.2s ease, transform 0.2s ease",
        mb: { xs: 2, sm: 0 },
      
        flex: 1,
        ...(exam.status == "standby-locked" || exam.status == "standby-open"
          ? {}
          : {
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#FFE0B2",
                transform: "scale(1.02)",
              },
            }),
      }}
      onClick={() => {
        if (exam.status == "graded") {
          window.open(exam.markingSchemeArtifactUri, "_blank");
        }
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography level="title-lg" sx={{ mb: 2, color: "#E65100" }}>
          Marking Scheme
        </Typography>
        <NorthEastIcon sx={{ mb: 2, color: "#E65100", fontSize: 20 }} />
      </Stack>
      <Box
        sx={{
          position: "absolute",
          bottom: "8%",
          right: "8%",
          opacity: 0.15,
          transform: "scale(2.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <GradingRoundedIcon sx={{ fontSize: 40 }} />
      </Box>
    </Card>
  );
}
